/**
 * 门户返回默认配置数据
 */
export const home = [{}]

/**
 * 大屏返回默认配置数据
 */
export const bs = [{
    // activeBgColor:"F0F2F7",
    // activeFontColor:"rgba(0, 0, 0, 0.8)",
    // selectBgColor:"#000",
    // color:"rgba(242, 242, 242, 0.8)",
    // hoverBgColor:"#F0F2F7",
    iconSrc:"70109268C01B1E53",
    background:"rgba(0, 0, 0, 0)",
    ulBgColor:"rgba(0, 0, 0, 0.75)",
    topNavBackground:{
        color:"rgba(0, 0, 0, 0.8)",
        isThemeColor:false,
        label:"颜色",
        type:"color"
    },
    selectBoxShadowColor : [], // 下拉列表的阴影
    selectBoxShadowH : [],
    selectBoxShadowV : [],
    selectBoxShadowBlur : [],
    selectBoxShadowSpread : []
}]

/**
 * app多级菜单默认配置数据
 */
export const appHome = [{}]